import { createSelector } from 'reselect'

export const authorization = state => state.authorization

export const accessTypeSelector = createSelector(
  authorization,
  (authorization) => authorization.accessType
)

export const campaignSelector = createSelector(
  authorization,
  (authorization) => authorization.campaign
)

export const authIdSelector = createSelector(
  authorization,
  (authorization) => authorization.authId
)
